"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const _utils_1 = require("@utils");
const _theme_1 = require("@theme");
var Onionskin = styled_components_1.default.div.withConfig({
    displayName: "Onionskin",
    componentId: "sc-75rcco-0"
})(["z-index:89;position:fixed;top:0;left:0;background-color:", ";width:100%;height:100vh;transform:translateY(", "px);opacity:", ";visibility:", ";pointer-events:", ";transition:transform 0.35s ease-in-out 0.1s,opacity 0.6s ease-in-out,visibility 0.6s ease-in-out;will-change:transform,opacity;backface-visibility:hidden;", "{transform:translateY(", "px);}"], _utils_1.rgba(_theme_1.palette.black, 0.4), function (props) {
    return !props.compactHeader ? 0 : 16;
}, function (props) {
    return props.hide ? 0 : 1;
}, function (props) {
    return props.hide ? 'hidden' : 'visible';
}, function (props) {
    return props.hide ? 'none' : 'all';
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !props.compactHeader ? 0 : 24;
});
exports.default = Onionskin;
